import { AbstractStockProvider, StockList, ReasonList, AccessTokenResponse, TickerDataResponse, TickersResponse } from "../../providers/stock/types";
import { AbstractStockService, AbstractStockServiceSetter } from "./types";



export class StockService  implements AbstractStockService {
  private provider: AbstractStockProvider;
  private setter: AbstractStockServiceSetter;

  constructor(provider: AbstractStockProvider, setter: AbstractStockServiceSetter) {
    this.setter = setter;
    this.provider = provider;
  }

  
  async getMomentumStocks(date: string):Promise<StockList> {
    return this.provider.getMomentumStocks(date) as Promise<StockList>;
  }

  async getTrendingStocks(date: string):Promise<StockList> {
    return this.provider.getTrendingStocks(date) as Promise<StockList>;
  }

  async getStockMovements():Promise<StockList> {
    return this.provider.getStockMovements() as Promise<StockList>;
  }

  async GetStockReasoning(date: string, symbol: string, runner_type: string) {
    return  this.provider.GetStockReasoning(date, symbol, runner_type) as Promise<ReasonList>;
  }

  async GetAccessToken(api_key:string, api_secret:string) {
    const data = await this.provider.GetAccessToken(api_key, api_secret);
    this.setter.updateCustomer(data.accessToken);
    return data;
  }

  async DownloadStockData(ticker: string, interval: string, startDate: string, endDate: string, accessToken: string): Promise<Blob> {
    return this.provider.DownloadStockData(ticker, interval, startDate, endDate, accessToken) as Promise<Blob>;
  }

  async getTickerData(isin: string, interval: string, startDate: string, endDate: string, accessToken: string): Promise<TickerDataResponse> {
    return this.provider.getTickerData(isin, interval, startDate, endDate, accessToken) as Promise<TickerDataResponse>;
  }

  async getTickers(accessToken: string, type?: string, exchange?: string): Promise<TickersResponse> {
    return this.provider.getTickers(accessToken, type, exchange) as Promise<TickersResponse>;
  }
}